export const fetchArticleDetails =
  ({ variant, supplier, runNumber, kbn, contextChannelId }) =>
  async (_dispatch, _getState, { gccApiClient }) => {
    const data = await gccApiClient.getArticleDetails({
      variant,
      supplier,
      runNumber,
      kbn,
      contextChannelId,
    });
    return data;
  };
